import { memo } from 'react'
import { Box } from '@labrav/react-components'
import { useStyles } from './LicenseAgreement.styles'
import { PictureAsPdfOutlined } from '@mui/icons-material'
import { useSelector } from '../../../store'
import { isEmpty } from 'lodash'

interface LicenseAgreementProps {
  endCustomerEulaType?: null | string
  endCustomerEulaFiles?: string[]
  resellerLicenseAgreementType?: null | string
  resellerLicenseAgreementFiles?: null | string[]
}

const AgreementFile = memo(
  ({ href, fileName }: { href: string; fileName: string }) => {
    const { classes } = useStyles()
    return (
      <a
        className={classes.agreementFile}
        download={name}
        href={href}
        data-testid="agreementFile"
      >
        <PictureAsPdfOutlined className={classes.pdfIcon} /> {fileName}
      </a>
    )
  }
)

export const LicenseAgreement = memo(() => {
  const { classes } = useStyles()
  const licenseAgreementValues = useSelector<Partial<LicenseAgreementProps>>(
    ({ cppoResellerAgreement }) => ({
      endCustomerEulaType: cppoResellerAgreement.endCustomerEulaType,
      endCustomerEulaFiles: cppoResellerAgreement.endCustomerEulaFiles,
      resellerLicenseAgreementType:
        cppoResellerAgreement.resellerLicenseAgreementType,
      resellerLicenseAgreementFiles:
        cppoResellerAgreement.resellerLicenseAgreementFiles,
    })
  )
  const {
    endCustomerEulaType,
    endCustomerEulaFiles,
    resellerLicenseAgreementType,
    resellerLicenseAgreementFiles,
  } = licenseAgreementValues

  if (
    isEmpty(licenseAgreementValues) ||
    !endCustomerEulaFiles?.length ||
    !resellerLicenseAgreementFiles?.length
  ) {
    return <div></div>
  }
  return (
    <div className={classes.root}>
      <Box heading={'License Agreement'} subHeading={''}>
        <div className={classes.agreementContainer}>
          <div className={classes.agreementTitle}>
            End user License agreement
          </div>
          {endCustomerEulaType && (
            <div className={classes.agreementType}>{endCustomerEulaType}</div>
          )}
          {endCustomerEulaFiles && (
            <div className={classes.agreementFiles}>
              {endCustomerEulaFiles.map((href, index) => (
                <AgreementFile
                  key={href + index}
                  href={href}
                  fileName={`EULA${index + 1}.pdf`}
                />
              ))}
            </div>
          )}
        </div>
        {resellerLicenseAgreementFiles &&
          !!resellerLicenseAgreementFiles.length && (
            <div className={classes.agreementContainer}>
              <div className={classes.agreementTitle}>
                Reseller License Agreement
              </div>
              {resellerLicenseAgreementType && (
                <div className={classes.agreementType}>
                  {resellerLicenseAgreementType}
                </div>
              )}
              <div className={classes.agreementFiles}>
                {resellerLicenseAgreementFiles.map((href, index) => (
                  <AgreementFile
                    key={href + index}
                    href={href}
                    fileName={`RLA${index + 1}.pdf`}
                  />
                ))}
              </div>
            </div>
          )}
      </Box>
    </div>
  )
})
